import { Get, Post } from "./common";

export default class PaymentService {
  static create = async (token: string, data: any) =>
    await Post({ path: "payments", token, body: data });

  static getStatus = async (token: string, data: any) =>
    await Post({ path: "payments/status", token, body: data });

  static getSellerPayments = async (token: string, data: any) =>
    await Post({ path: "payments/seller", token, body: data });

  static getBuyerPayments = async (token: string, data: any) =>
    await Post({ path: "payments/buyer", token, body: data });

  static startShipping = async (token: string, data: any) =>
    await Post({ path: "payments/start-shipping", token, body: data });

  static trackShipment = async (token: string, data: any) =>
    await Post({ path: "payments/track-shipment", token, body: data });

  static confirmDelivery = async (token: string, data: any) =>
    await Post({ path: "payments/confirm-delivery", token, body: data });

  static createTrustapComplaint = async (token: string, data: any) =>
    await Post({ path: "payments/trustap-complaint", token, body: data });

  static claimPayout = async (token: string, data: any) =>
    await Post({ path: "payments/claim-payout", token, body: data });

  static diagnoseClaim = async (token: string, paymentId: string) =>
    await Get({ path: `payments/diagnose-claim/${paymentId}`, token });
}
